import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-resilience-challenge-list',
  templateUrl: './resilience-challenge-list.component.html',
  styleUrls: ['./resilience-challenge-list.component.scss'],
})
export class ResilienceChallengeListComponent implements OnInit {
  @Input() challenges: string[];
  @Input() title: string;

  constructor() {}

  ngOnInit(): void {}
}
